export const BASE_URL = 'https://cslbauth.uk';

export const API_ENDPOINTS = {
    GENERATE_SESSION_ID: 'share/generateSessionId',
    CHECK_SESSION_ID: 'share/checkIfSessionValid',
    SHARE_DATA: 'share/encryptInputData',
    GET_DATA: 'share/getData',

};
